import React, { useState, useEffect } from 'react';
import { Accordion, AccordionSummary, AccordionDetails, Typography,Grid } from '@mui/material';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import WorkerNavBar from '../NavigationBar/WorkerNavBar';
import WorkerAttendanceGateKeeper from './WorkerAttendanceGateKeeper';

import supabase from '../../supabaseClient';

const WorkerMainView = () => {

  const [userID, setUserID] = useState('');
  const [idConfig, setIdConfiguration] = useState('');
  const [hiddenSimpleLocationConfirmation, setHiddenSimpleLocationConfirmation] = useState(null);
useEffect(() => {
  const checkSession = async () => {
    const { data } = await supabase.auth.getSession();
    if (data.session) {
      setUserID(data.session.user.id);
      fetchData(data.session.user.id);
    }
  };
  checkSession();
}, []);

const fetchData = async (userId) => {
  const { data: profileData, error: profileError } = await supabase
    .from('profiles')
    .select('id_configuration')
    .eq('id', userId)
    .single();
  if (profileError) {
    console.log(profileError);
  } else if (profileData) {
    setIdConfiguration(profileData.id_configuration);
  }
};





  return (
    <WorkerNavBar>
      <WorkerAttendanceGateKeeper></WorkerAttendanceGateKeeper>
    </WorkerNavBar>
  );
};

export default WorkerMainView;
